import React__default from "react";
const $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c = typeof document !== "undefined" ? React__default.useLayoutEffect : () => {
};
export {
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c as useLayoutEffect
};
